module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_4.4f1fdfad60652343f408772d12e43127.png";